import { render, staticRenderFns } from "./AddOfferItems.vue?vue&type=template&id=7d2e67af&scoped=true"
import script from "./AddOfferItems.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddOfferItems.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AddOfferItems.vue?vue&type=style&index=0&id=7d2e67af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d2e67af",
  null
  
)

export default component.exports